// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__34dy1","left":"StickyBox_left__14tFw","right":"StickyBox_right__2pJBa"};